const toNonNegativeNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : fallback;
};

export const normalizeVariantRecipes = (recipes = []) => {
  const seenMaterials = new Set();

  return recipes.reduce((result, recipe) => {
    const materialId = Number(recipe?.material_id);
    if (!materialId || seenMaterials.has(materialId)) return result;

    seenMaterials.add(materialId);
    result.push({
      material_id: materialId,
      unit: recipe?.unit || recipe?.material_unit || "pcs",
      weight: toNonNegativeNumber(recipe?.weight),
      qty: Math.max(0.0001, toNonNegativeNumber(recipe?.qty, 1)),
    });

    return result;
  }, []);
};

export const buildProductGroupPayload = (formState = {}) => ({
  name: String(formState?.name || "").trim(),
  option_name: String(formState?.option_name || "").trim(),
  category: formState?.category || null,
  type: formState?.type || null,
  image: formState?.image || formState?.image_path || "",
  description: String(formState?.description || "").trim(),
  is_display_landing: Number(Boolean(Number(formState?.is_display_landing || 0))),
  replace_variants: true,
  variants: (formState?.variants || []).map((variant, index) => ({
    ...(variant?.id ? { id: Number(variant.id) } : {}),
    label: String(variant?.label || variant?.variant_label || "").trim(),
    sku: String(variant?.sku || "").trim(),
    inventory_mode: variant?.inventory_mode || "made_to_order",
    unit: variant?.unit || "pcs",
    unit_price: toNonNegativeNumber(variant?.unit_price),
    stock: toNonNegativeNumber(variant?.stock),
    min_stock: toNonNegativeNumber(variant?.min_stock),
    max_stock: toNonNegativeNumber(variant?.max_stock),
    is_default_variant: Boolean(variant?.is_default_variant ?? index === 0),
    sort_order: toNonNegativeNumber(variant?.sort_order, index),
    recipes: normalizeVariantRecipes(variant?.recipes || variant?.materials || []),
  })),
});

